import type { Customer } from '../../services/customer.service';
import type { SeasonStatus } from '../../utils/seasonStatus';

export const UPCOMING_THRESHOLD_OPTIONS = [15, 30, 45, 60, 75, 90] as const;

export interface CropStatusFilters {
  status: SeasonStatus | '';
  cropTypeId: string;
  regionId: string;
  groupByCropType: boolean;
  upcomingThresholdDays: number;
  viewMode?: 'table' | 'timeline';
}

export type ViewMode = 'table' | 'timeline';

export interface ResultRow {
  customer: Customer;
  cropTypeId: string;
  regionId: string;
}

export type EmptyReason = 'no-status' | 'no-seasons' | 'no-customers';

export const STORAGE_KEY = 'agrobook_crop_status_filters';
export const DEFAULT_FILTERS: CropStatusFilters = { status: 'in-season', cropTypeId: '', regionId: '', groupByCropType: true, upcomingThresholdDays: 30, viewMode: 'table' };
